import { render, staticRenderFns } from "./answerRecord.vue?vue&type=template&id=08379cf2&scoped=true"
import script from "./answerRecord.vue?vue&type=script&lang=js"
export * from "./answerRecord.vue?vue&type=script&lang=js"
import style0 from "./answerRecord.vue?vue&type=style&index=0&id=08379cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08379cf2",
  null
  
)

export default component.exports